export const enGB = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "Lassie",
  legalName: "Lassie Pet Health Ltd",
  url: "https://uk.lassie.co",
  logo: "https://uk.lassie.co/images/logo-with-name.svg",
  description:
    "Prevention-focused lifetime pet insurance for dogs and cats in the UK. Vet fee cover up to £20,000 per year, claims through the app or direct to your vet, and rewards for preventive care.",
  email: "hello@lassie.co.uk",
  telephone: "+442046524500",
  address: {
    "@type": "PostalAddress",
    streetAddress:
      "C/O DAC Beachcroft LLP, First Floor, Woolgate, 25 Basinghall Street",
    postalCode: "EC2V 5HA",
    addressLocality: "London",
    addressCountry: "GB",
  },
  sameAs: [
    "https://www.facebook.com/profile.php?id=61586107754432",
    "https://www.instagram.com/lassie_uk",
    "https://www.youtube.com/@lassie_co",
    "https://www.linkedin.com/company/lassieco/",
  ],
  hasOfferCatalog: {
    "@type": "OfferCatalog",
    name: "Insurance",
    itemListElement: [
      {
        "@type": "OfferCatalog",
        name: "Dog Insurance",
        itemListElement: [
          {
            "@type": "Offer",
            itemOffered: {
              "@type": "Service",
              name: "Dog Insurance Bronze",
              description:
                "Basic protection for veterinary care. £4,000 vet fee cover per year. Accident, illness and prescribed medication, dental accident, emergency treatment in the EU.",
            },
            potentialAction: [
              {
                "@type": "BuyAction",
                target: "https://uk.lassie.co/signup/?species=dog",
              },
            ],
          },
          {
            "@type": "Offer",
            itemOffered: {
              "@type": "Service",
              name: "Dog Insurance Silver",
              description:
                "All the essentials at a reasonable price. £8,000 vet fee cover per year. Accident, illness and prescribed medication, dental accident and illness, emergency treatment in the EU.",
            },
            potentialAction: [
              {
                "@type": "BuyAction",
                target: "https://uk.lassie.co/signup/?species=dog",
              },
            ],
          },
          {
            "@type": "Offer",
            itemOffered: {
              "@type": "Service",
              name: "Dog Insurance Gold",
              description:
                "Reimburses large healthcare costs. £12,000 or £20,000 vet fee cover per year. Accident, illness and prescribed medication, dental accident and illness, worldwide emergency treatment.",
            },
            potentialAction: [
              {
                "@type": "BuyAction",
                target: "https://uk.lassie.co/signup/?species=dog",
              },
            ],
          },
        ],
      },
      {
        "@type": "OfferCatalog",
        name: "Cat Insurance",
        itemListElement: [
          {
            "@type": "Offer",
            itemOffered: {
              "@type": "Service",
              name: "Cat Insurance Bronze",
              description:
                "Basic protection for veterinary care. £4,000 vet fee cover per year. Accident, illness and prescribed medication, dental accident, emergency treatment in the EU.",
            },
            potentialAction: [
              {
                "@type": "BuyAction",
                target: "https://uk.lassie.co/signup/?species=cat",
              },
            ],
          },
          {
            "@type": "Offer",
            itemOffered: {
              "@type": "Service",
              name: "Cat Insurance Silver",
              description:
                "All the essentials at a reasonable price. £8,000 vet fee cover per year. Accident, illness and prescribed medication, dental accident and illness, emergency treatment in the EU.",
            },
            potentialAction: [
              {
                "@type": "BuyAction",
                target: "https://uk.lassie.co/signup/?species=cat",
              },
            ],
          },
          {
            "@type": "Offer",
            itemOffered: {
              "@type": "Service",
              name: "Cat Insurance Gold",
              description:
                "Reimburses large healthcare costs. £12,000 or £20,000 vet fee cover per year. Accident, illness and prescribed medication, dental accident and illness, worldwide emergency treatment.",
            },
            potentialAction: [
              {
                "@type": "BuyAction",
                target: "https://uk.lassie.co/signup/?species=cat",
              },
            ],
          },
        ],
      },
      {
        "@type": "OfferCatalog",
        name: "Add-ons",
        itemListElement: [
          {
            "@type": "Offer",
            itemOffered: {
              "@type": "Service",
              name: "Death Cover Add-on",
              description:
                "Optional add-on that pays out if your pet dies from an accident or illness covered by the policy.",
            },
            potentialAction: [
              {
                "@type": "BuyAction",
                target: "https://uk.lassie.co/death-cover-add-on",
              },
            ],
          },
        ],
      },
    ],
  },
};
